import type { Slide } from '../types'

export const normalizeSettingsHeroSlide = (raw: Record<string, unknown>): Slide => ({
  id:
    (typeof raw._id === 'string' && raw._id) ||
    (typeof raw.id === 'string' && raw.id) ||
    `slide-${Math.random().toString(36).slice(2, 8)}`,
  title: typeof raw.title === 'string' ? raw.title : '',
  description: typeof raw.description === 'string' ? raw.description : '',
  ctaLabel: typeof raw.ctaLabel === 'string' ? raw.ctaLabel : undefined,
  ctaHref: typeof raw.ctaHref === 'string' ? raw.ctaHref : undefined,
  image:
    (typeof raw.image === 'string' && raw.image) ||
    (raw.imageVariants &&
    typeof raw.imageVariants === 'object' &&
    typeof (raw.imageVariants as { large?: unknown }).large === 'string'
      ? ((raw.imageVariants as { large?: string }).large ?? undefined)
      : undefined) ||
    (raw.imageVariants &&
    typeof raw.imageVariants === 'object' &&
    typeof (raw.imageVariants as { medium?: unknown }).medium === 'string'
      ? ((raw.imageVariants as { medium?: string }).medium ?? undefined)
      : undefined),
})
